import React, { useRef, useCallback, useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Visibility } from '@material-ui/icons';


import { isNull } from 'lodash';
import { UnidataTable } from '~/components';
import {
  deleteFrentista,
  findFrentista,
  recordFiltering,
  changePosto
} from '~/store/modules/frentista/actions';

import { resetParams } from '~/store/modules/hooks/actions';
import { Typography } from '@material-ui/core';

import { format, setHours, setMinutes, setSeconds, subDays, parseISO } from 'date-fns';


import { FieldsForm } from './styles';
import Form from './form';
import DetalheFrentista from './components/DetalheFrentista';
import { SelectComplete } from '~/componentslocal';

function FrentistaList() {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.frentista);
  const [hasCustom, setHasCustom] = useState(true)
  const [showCustom, setShowCustom] = useState(false)
  const [isGPPM, setIsGPPM] = useState(false)

  const [showTable, setShowTable] = useState(true)
  const { profile } = useSelector((state) => state.user)

  const [selectedPosto, setSelectedPosto] = useState({})

  const modalRef = useRef(null);
  const formRef = useRef(null);

  const listaBloqueioPorAcesso = useMemo(() => [
    { label: 'S', value: 'Sim' },
    { label: 'N', value: 'Não' }
  ])

  const listaStatusPesquisa = useMemo(() => [
    { label: '1', value: 'liberado' },
    { label: '2', value: 'bloqueado' },
    { label: '3', value: 'cancelado' },
  ]);


  useEffect(() => {
    if (profile.perf_tipo == 6) {
      setHasCustom(false)
    } else if (profile.perf_tipo == 8) {
      setIsGPPM(true)
    }

    setShowCustom(true)
  }, [])


  useEffect(() => {

    return () => {
      dispatch(resetParams())
    }

  }, [])

  const optionsUser = useMemo(
    () => [
      { label: 'Liberado', value: 'Liberado' },
      { label: 'Bloqueado', value: 'Bloqueado' },
      { label: 'Cancelado', value: 'Cancelado' },
    ],
    []
  );

  const header = useMemo(
    () => [
      { id: 'usua_login', label: 'Código', filter: { type: 'text' } },
      { id: 'usua_nome', label: 'Nome', filter: { type: 'text' } },
      { id: 'usua_cpf', label: 'CPF', filter: { type: 'text' } },


      {
        id: 'usua_status_str',
        label: 'Status',
        formatted: (value) =>
          optionsUser.find((option) => option.label === value).value,
        filter: { type: 'select', options: optionsUser },
        styled: (value) =>
          value.usua_status_str === 'Liberado' ? { color: '#00B300' } : { color: '#ff0000' },
      },

      {
        id: 'usua_ultimo_acesso',
        label: 'Último Acesso',
        align: 'center',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'usua_status_bloqueio_por_acesso',
        label: 'Bloqueio por tempo acesso',
        align: 'center',
        filter: {
          type: 'select',
          options: listaBloqueioPorAcesso,
        },
        formatted: (value) => value == 'S' ? 'Sim' : 'Não',

        // styled: (value) =>
        //   value.usua_status_str === 'liberado' ? { color: '#00B300' } : { color: '#ff0000' },
      },


    ],
    [optionsUser]
  );

  const handleSelectPosto = useCallback(async (value) => {
    await setShowTable(false)
    if (isNull(value.poco_codigo)) {
      // dispatch(recordFiltering({ ...data.params, poco_codigo: '', page: 1 }))
      await dispatch(changePosto({ poco_codigo: '' }))
    } else {
      // dispatch(recordFiltering({ ...data.params, poco_codigo: value.poco_codigo, page: 1 }))
      await dispatch(changePosto({ poco_codigo: value.poco_codigo }))
    }
    setSelectedPosto(value)
    await setShowTable(true)
  }, [data])


  const buttons = useMemo(
    () => [
      {
        title: 'Detalhes',
        icon: <Visibility />,
        action: (value) => modalRef.current.handleToggleModal(value),
      },
    ],
    []
  );

  const handleUpdate = useCallback(() => {
    dispatch(recordFiltering(data.params));
  }, [data.params]);



  return (
    <>
      {hasCustom &&

        <FieldsForm reference={formRef} onSubmit={handleSelectPosto} >
          <Typography variant="h6" color="primary" >Selecione um posto:</Typography>

          {showCustom && <SelectComplete
            includeInputInList
            disabledItemsFocusable
            name="poco_codigo"
            label="poco_desc_abrev"
            title="Posto"
            url={isGPPM ? "postoscomboios/postosusuario" : "postoscomboios"}
            unique="poco_codigo"
            getValue={(value) => handleSelectPosto(value)}
            disableClearable={!selectedPosto.poco_codigo}
            params={isGPPM ? {
              wherefield: 'usua_login',
              valuewherefield: profile.id,
              typewherefield: 'EQUALS',
            } : {}}

          />}

          <p style={{ color: 'red' }}>* Ao selecionar um posto, todos os filtros da tabela serão resetados.</p>
        </FieldsForm>
      }

      {showTable && <UnidataTable
        reportOrder="usua_nome ASC"
        fixed
        header={header}
        redux={data}
        actions={buttons}
        keys="usua_login"
        detach="usua_nome"
        read={recordFiltering}
        find={findFrentista}
        remove={deleteFrentista}
        form={Form}
        view="VW_FRENTISTA_RETORNA_ASSOCIADOS_AO_POSTO_DO_USUARIO"
        reportTitle="Cadastro de Frentista"
      />}


      <DetalheFrentista ref={modalRef} update={handleUpdate} name="detalhe" />
    </>
  );
}

export default FrentistaList;
